import { render, staticRenderFns } from "./SectionCloudFeatures.vue?vue&type=template&id=715fa6d7&scoped=true"
import script from "./SectionCloudFeatures.vue?vue&type=script&lang=ts"
export * from "./SectionCloudFeatures.vue?vue&type=script&lang=ts"
import style0 from "./SectionCloudFeatures.vue?vue&type=style&index=0&id=715fa6d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715fa6d7",
  null
  
)

export default component.exports